import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  state() {
    return {
      uname: null,
      token: null,
      sessionLive: null,
      permissions: null,
      fullname: null,
      phoneInfo: null,
      workPlace: null,
      workPhone: null,
      plugings: null,
      usePhone: null,
      skills: null,
      domain: null,
      type: null,
      status: 1,
      restEndtime: null,
      avatar: null,
      profile: null,
      inCall: false,
      isConnected: false,
      shortCodes: null,
      smsLogs: null,
      CRMInitInfo: null,

      answerRequest: false,
      holdRequest: false,
      muteRequest: false,
      hangupRequest: false,

      isAnswered: false,
      isMute: false,
      isHolding: false,
      isIncoming: false,
      isOutgoing: false,
      sessionPeer: null,
      currentCall: null,
      socketKey: "",
      chatSocket: null,
      incomingSocketMessage: null,
      incomingSocketOmniMessage: null,
      currentChatID: null,
      currentOmniID: null,
      notReadChatMessages: null,
      notReadOmniMessages: null,
      differentTABRead: null,
      differentTABSent: null,

      omniActiveConversations: null,
      omniUsers: null,
      omniOpenedConversation: null,
      handleOpenedOmniConversation: null,
      omniDifferentTABRead: null,
      omniDifferentTABSent: null,
      omniConversationClosed: null,
      assignedOmniConversation: null,
      omniCloseOverlay: false,
      omniClosedCustomer: "",
      omniFailedMsg: null,
      acwSettings: null,
      acwStatus: null,
      inAcw: false,
      assistantChat: null,
      assistantAsk: null,
      crmLocalFields: null,
      ticketingLocalFields: null,
      callsList: null,
      numberToCall: "",
      isWhispering: false,
      whisperedAgent: null,
      whisperedChannel: null,
    };
  },
  mutations,
  actions,
  getters,
};
